import { render } from "./PatientCrudView.vue?vue&type=template&id=a817b740&scoped=true"
import script from "./PatientCrudView.vue?vue&type=script&lang=js"
export * from "./PatientCrudView.vue?vue&type=script&lang=js"

import "./PatientCrudView.vue?vue&type=style&index=0&id=a817b740&lang=css&scoped=true"

import exportComponent from "/home/runner/work/Frontend_PsicoApp/Frontend_PsicoApp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a817b740"]])

export default __exports__